import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const navLinks = [
  { labelKey: "home", path: "/" },
  { label: "猫咪养护", path: "/category/yanghu" },
  { label: "健康问答", path: "/category/jiankang" },
  { label: "萌猫图片", path: "/category/mengtu" },
  { label: "领养信息", path: "/category/lingyang" },
  { label: "行为解读", path: "/category/xingwei" },
  { label: "饮食营养", path: "/category/yinshi" },
];

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16" aria-label="主导航">
        <Link
          to="/"
          className="flex items-center gap-2 text-xl font-heading text-foreground-900 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
        >
          <span className="w-8 h-8 flex items-center justify-center">
            <i className="fa-solid fa-cat text-xl text-primary-500"></i>
          </span>
          猫咪社区
        </Link>

        <div className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => {
            const isActive = link.path === "/" ? location.pathname === "/" : location.pathname.startsWith(link.path);
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 text-sm rounded-md transition-colors duration-200 whitespace-nowrap ${
                  isActive
                    ? "text-primary-500 bg-primary-50 font-medium"
                    : "text-foreground-600 hover:text-primary-500 hover:bg-background-100"
                }`}
              >
                {link.labelKey ? t(link.labelKey) : link.label}
              </Link>
            );
          })}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <Link
            to="/about"
            className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
          >
            {t("about")}
          </Link>
          <Link
            to="/about"
            className="px-4 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            {t("join_community")}
          </Link>
        </div>

        <button
          className="lg:hidden w-10 h-10 flex items-center justify-center text-foreground-700"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="打开菜单"
          aria-expanded={mobileOpen}
        >
          <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="lg:hidden bg-background-50 border-b border-background-200/70 px-4 pb-4">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = link.path === "/" ? location.pathname === "/" : location.pathname.startsWith(link.path);
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-3 py-2.5 text-sm rounded-md transition-colors duration-200 whitespace-nowrap ${
                    isActive
                      ? "text-primary-500 bg-primary-50 font-medium"
                      : "text-foreground-600 hover:text-primary-500 hover:bg-background-100"
                  }`}
                >
                  {link.labelKey ? t(link.labelKey) : link.label}
                </Link>
              );
            })}
            <Link
              to="/about"
              className="px-3 py-2.5 text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
            >
              {t("about")}
            </Link>
            <Link
              to="/about"
              className="mt-2 px-4 py-2.5 text-sm font-medium bg-primary-500 text-background-50 rounded-full text-center hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              {t("join_community")}
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}